// config.ibadia.js
  /*

  Edgar Estarli (eesterli@xtec.cat)

   CICLES 

   comprovantAcceptacioPlaca
   authSortidaAbsencia

    // DADES AUTORITZACIONS 
    authCompromis
    authGDPR
    authResponsable
    authSortides
    authSortidaAbsencia
    authMedica
    authDretsImatge
    authMobils
    authRecursosDigitals
  */

const textInscripcioText = () =>  {

  //return (<>CONSULTEU LA <a href="http://www.inscavallbernat.cat/" target="_blank" rel="noreferrer">PÀGINA WEB DE L'INSTITUT CAVALL BERNAT</a> PER INFORMAR-VOS DEL MATERIAL I ELS LLIBRES QUE NECESSITEU PER INICIAR EL CURS</>)
  return (<></>)

}

const textPopupBaixaAcademica = () => (
  <>
    Accepto que l’alumnat que formalitzi la baixa acadèmica fins al 31 d’octubre (inclòs)
    tindrà dret a la devolució de l’import abonat en concepte de matrícula. A partir de l’1
    de novembre, no es realitzarà cap devolució de l’import de la matrícula, independentment
    del motiu de la baixa acadèmica. Veure condicions a:{' '}
    <a href="https://agora.xtec.cat/insbadia/secretaria/matricula26-27/" target="_blank" rel="noreferrer">
      https://agora.xtec.cat/insbadia/secretaria/matricula26-27/
    </a>
  </>
)

const config =
{
    cid: 'a8042342',

    // llistat dels camps d'autorització del pas "Protecció de dades" d'aquest centre
    // (veure src/components/enrolmentform/authorizations/ibadia/)
    autoritzacions: [
        'authCompromis', 'authDretsImatge', 'authGDPR', 'authMedica', 'authMobils',
        'authRecursosDigitals', 'authResponsable', 'authSortidaAbsencia', 'authSortides',
    ],

    phone: "937187506",
    email: "a8042342@xtec.cat",

    headerLogo:  'img/logo_bn_ibadia.png',
    headerTitle:  'Institut de Badia del Vallès',
    headerURL: 'https://matricula.ibadia.cat/',

    //enrollmentPostURL: 'https://matricula.ibadia.cat/post/',
    enrollmentPostURL: '/post/',
    //apiURL: 'https://matricula.ibadia.cat/api/',
    apiURL: '/api/',

    popupInicial: true,

    /* popup previ, no es pot tancar fins que l'usuari marqui el checkbox d'acceptació */
    popupBaixaAcademica: true,
    textPopupBaixaAcademica: textPopupBaixaAcademica(),

    /* valor per defecte (mandatori); es pot sobreescriure per curs concret amb
       curs.adjuntarArxiusNoObligatori a les dades de families (chkiddoc + cursObligatori);
       aquest valor només s'aplica a la matrícula lliure, sense curs obligatori */
    adjuntarArxiusNoObligatori: false,

    // llibre de família (plana progenitors + plana alumne) obligatori per als menors d'edat
    llibreFamiliaObligatori: false,

    validaIDdocuments: true,
    tipusDocTSI: true,

    fotoCarnet: true,
    validaIAfotoCarnetFile: true,

    textAutoritzoComunicacioProgenitors : "Autoritzo que els meus progenitors/tutors legals puguin rebre comunicats de l’institut i accedir a la meva informació acadèmica.",

    telefonObligatori: true,
    carnetFamiliaNombrosa: false,

    contacteEmergenciaObligatori: true,

    adjuntMedic: true,
    adjuntMedicObligatori: false,

    //datesNoBloquejenInscripcio: false,
    datesNoBloquejenInscripcio: false,

    noPreguntarSiEsNouAlumne: false,

    notesAcces: false,
    
    mostraTorns: false,
    
    logo: 'img/logo_ibadia.jpg',
    titol: 'Institut de Badia del Vallès',
    
    favicon: '/img/favicon-ibadia.ico',
    faviconGestio: '/gestio/img/favicon-ibadia.ico',
    
    assignatures: 'assignatures/assignatures.ibadia.json',
    families: 'families/families.ibadia.json',
    dadesbancaries: 'dadesbancaries/dadesbancaries.ibadia.json',
    calculquota: 'quotes.ibadia.json',
    
    /* camps especifics per centre */
    treballantFile: true,
    necessitatsEducativesEspecials: true,
    necessitatsEducativesEspecialsDesplegable: [
                                                {id: "nouvingut", value: "Nouvinguts (-2 anys)"},
                                                {id: "tea", value: "TEA"},
                                                {id: "dislexia", value: "Dislèxia"},
                                                {id: "tdha/tda", value: "TDHA/TDA"},
                                                {id: "discapacitat", value: "Discapacitat física/cognitiva"},
                                                {id: "altres", value: "Altres"}
                                              ],
    
    repetidor: false,
    repetidorsNoPodenAgafarAssignaturesDe2n: false,
    
    textDadesMediquesAlgunSi: "",
    
    textBotoMatricular: "INSCRIURE",
    
    textAlumneNouAlCentre: "Ets alumne nou als estudis que et matricules?",
    textAlumneNouAlCentreSub: null,

    proporcionarPreinscripcioNous: true,// CANVIAT SETEMBRE
    proporcionarTitolPreinscripcioNous: true,
    
    //comprovantAcceptacioPlaca: true,
    comprovantAcceptacioPlaca: false, // CANVIAT SETEMBRE

    // CANVIAT SETEMBRE
    //textProporcionarPreinscripcioNous: "Cal proporcionar número de preinscripció, adjuntar títol pel qual s'accedeix i el comprovant d'acceptació de plaça per poder proseguir amb la matrícula de CFGM i CFGS.",
    textProporcionarPreinscripcioNous: "Cal proporcionar el títol pel qual s'accedeix per poder proseguir amb la matrícula de CFGM i CFGS.",


    urlTPV: "https://matricula.ibadia.cat/tpv/",
    pagamentTPV: true,
    pagamentTransferencia: false,

    textInscripcioText: null,

    /* el pagament en dos terminis només està habilitat durant el primer periòde de matriculacions */
    //dosTerminisEnabled: (new Date().getMonth() >= 4 && new Date().getMonth() <= 7),
    dosTerminisEnabled: (new Date().getMonth() >= 4 && new Date().getMonth() <= 12),
    /* si es fals mostrem unes altres condicions de pagament */
    dosTerminisEnabledFalseCondicio: 0,

    sexeNoBinari: true,

    pattern_batx_nocturn: /^BATXLOE\d{5}N[A-Z]{1,2}$/,
    pattern_1r_batx: /^BATXLOE\d{4}1[^N][A-Z]{1,2}$/,
    pattern_2n_batx: /^BATXLOE\d{4}2[^N][A-Z]{1,2}$/,

    su: ['WyIxMTExMTEx', 'MUgiLCIyMjIyMjIyM', 'koiLCI0NTQ5MjQwNVMiXQ=='],
  };

export default  config;